import React from "react"

import { gql, useMutation, useQuery } from "urql"

import CopilotView from "components/Copilot/CopilotView"

type CloudroomCopilotProps = {
  sessionId: string
}

const CloudroomCopilot: React.FC<CloudroomCopilotProps> = ({ sessionId }) => {
  const [{ data, fetching: historyLoading }] = useQuery({
    query: copilotResponsesQuery,
    variables: { sessionId },
  })
  const [{ fetching }, runMutation] = useMutation(
    copilotCreateSuggestionMutation
  )

  return (
    <CopilotView
      responses={data?.airtutorsSession?.copilotResponses}
      historyLoading={historyLoading}
      fetching={fetching}
      createSuggestion={endpoint => runMutation({ sessionId, endpoint })}
      headerText="Tutor CoPilot"
    />
  )
}

const copilotResponsesQuery = gql`
  query CopilotResponses($sessionId: ID!) {
    airtutorsSession(id: $sessionId) {
      copilotResponses {
        prompt
        response
      }
    }
  }
`

const copilotCreateSuggestionMutation = gql`
  mutation TutorCopilotCreateSuggestion(
    $sessionId: ID!
    $endpoint: CopilotEndpointEnum!
  ) {
    copilotCreateSuggestion(sessionId: $sessionId, endpoint: $endpoint) {
      copilotResponse
      failures {
        message
      }
    }
  }
`

export default CloudroomCopilot
